var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contrast-2-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21.9966C6.47715 21.9966 2 17.5195 2 11.9966C2 6.47374 6.47715 1.99658 12 1.99658C17.5228 1.99658 22 6.47374 22 11.9966C22 17.5195 17.5228 21.9966 12 21.9966ZM12 19.9966C16.4183 19.9966 20 16.4149 20 11.9966C20 7.57831 16.4183 3.99658 12 3.99658C7.58172 3.99658 4 7.57831 4 11.9966C4 16.4149 7.58172 19.9966 12 19.9966ZM7.00035 15.3159C9.07995 15.1645 11.117 14.2938 12.7071 12.7037C14.2972 11.1136 15.1679 9.07654 15.3193 6.99694C15.6454 7.21396 15.955 7.4663 16.2426 7.75394C18.5858 10.0971 18.5858 13.8961 16.2426 16.2392C13.8995 18.5824 10.1005 18.5824 7.75736 16.2392C7.46971 15.9516 7.21738 15.642 7.00035 15.3159Z",
    fill: "#0C111D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast2Line);
export default __webpack_public_path__ + "static/media/contrast-2-line.328f05ef60ae5f0ac104da7aa0639f17.svg";
export { ForwardRef as ReactComponent };